module.exports = __webpack_public_path__ + "static/media/lossIcon.13f3f55c.svg";